'use strict';

{
    var app = angular.module('tf.volatility', [])
        .controller('volatilityCtrl', ['$scope', '$state', 'uiGridConstants', 'uiGridExporterConstants', '$http', '$filter', function volatilityController($scope, $state, uiGridConstants, uiGridExporterConstants, $http, $filter) {

            var dateFilter = $filter('date');
            var percentFilter = $filter('percentage');

//            DATE PICKER STUFF - TODO cleanup based on what is used
            $scope.showDateMod = function() {
                $scope.isshowDateMod = !$scope.isshowDateMod;
            };
//            END DATEPICKER STUFF

            $scope.gridOptionsVolatilityOverTime = {
                flatEntityAccess : true,
                enableGridMenu: true,
                enableColumnResizing: true,
                enableFiltering: true,
                exporterMenuCsv: false,
                exporterMenuPdf: false,
                minRowsToShow : 15,
                enablePaging : false,
                excessRows : 20,
                enableHorizontalScrollbar : uiGridConstants.scrollbars.NEVER,
                exporterCsvFilename: 'iv_over_time.csv',
                enableRowHeaderSelection : false,
                multiSelect : false,
                columnDefs: [],
                onRegisterApi: function(gridApi){
                    $scope.gridApi = gridApi;
                    $scope.gridApi.selection.on.rowSelectionChanged($scope, selectOption);
                },

                data: []
            };

            function selectOption(row) {

                var option = row.entity;
                var columns = [];
                var rows = [];

                var undPriceData = [];
                var volData = [];

                for (var i = 0; i < $scope.points.length; i++) {

                    var point = $scope.points[i];

                    columns.push({
                        point : point,
                        underlyingPrice : option.underlying.prices[i],
                        optionPrice : option.prices[i],
                        delta : option.deltas[i]
                    });

                    undPriceData.push([i, option.underlying.prices[i]]);
                    volData.push([i, -option.vols[i]]);

                    var diffs = [];

                    for (var y = 0; y < option.vols.length; y++) {
                        var newPoint = Math.max(i, y);
                        var oldPoint = Math.min(i, y);
                        var diff = (option.vols[newPoint] - option.vols[oldPoint]) / option.vols[oldPoint];

                        diff = diff || 0;
                        diffs.push({diff : diff});

                        //worstCase = Math.max(Math.abs(diff), worstCase);
                    }

                    rows.push({
                        point : point,
                        differences : diffs
                    })
                }

                $scope.selectedOptionDetail = {
                    option : option,
                    underlying : option.underlying,
                    columns : columns,
                    rows : rows

                };

                $scope.volOverTime = [
                    {
                        "key": "Underlying",
                        "values": undPriceData
                    }
                    ,
                    {
                        "key": "Inv. Vol",
                        "values": volData
                    }

                ];
            }

            $scope.selectedOptionDetail = null;

            $scope.exportCsv = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
            };

            $scope.exportCsvVisible = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
            };

            $scope.volOverTime = [];

            const xAxisTickFormat = function() {
                return function(value) {
                    return dateFilter($scope.points[value], 'HH:mm');
                }
            };

            const yAxisTickFormat = function() {
                return function(value) {
                    return percentFilter(value, 2);
                }
            };

            $scope.chartOptions = {
                chart: {
                    type: "cumulativeLineChart",
                    height: "100%",
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 40,
                        left: 55
                    },
                    x(d) {
                        return d[0];
                    },
                    y(d) {
                        return d[1];
                    },
                    useInteractiveGuideline: true,
                    xAxis: {
                        axisLabel: "Date",
                        tickFormat: xAxisTickFormat()

                    },
                    yAxis: {
                        axisLabel: "%",
                        tickFormat: yAxisTickFormat(),
                        axisLabelDistance: -10
                    }
                }
            };

            $http.get('/tradefloor/api/historical-model').then(function(response) {
                var data = response.data;
                var newTableData = [];
                var points = data.points;
                $scope.points = points;
                $scope.pointInTime = data.pointInTime;

                var columns = [];
                columns.push({ name: 'code', type : 'string', displayName : 'ASX Code', width: '*'});
                columns.push({
                    name: 'worstCase',
                    type : 'string',
                    displayName : 'Biggest Change',
                    width: '*',
                    cellFilter : 'percentage:2',
                    headerCellClass: 'gridNumber',
                    cellClass: 'gridNumber'
                });


                for (var i = 0; i < points.length; i++) {
                    var point = points[i];

                    columns.push({
                        name: 'vols' + i,
                        type : 'number',
                        cellFilter : 'percentage:2',
                        headerCellFilter : 'date : \'EEE HH:mm\'',
                        displayName: dateFilter(point, 'EEE HH:mm'),
                        width: '*',
                        headerCellClass: 'gridNumber',
                        cellClass: 'gridNumber'
                    });
                }


                columns.push({name: 'strike', type : 'number', displayName: 'Strike',
                    filter : {
                        condition: uiGridConstants.filter.EXACT
                    },
                    width: '*', headerCellClass: 'gridNumber',
                    cellClass: 'gridNumber', cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.strike | strike:row.entity.code.indexOf(\'XJO\') == 0}}</div>'});
                columns.push({name: 'expiry', type : 'string', displayName: 'Expiry', width: '*', cellFilter : 'date: \'MMM yy\'', filter : {
                    condition: uiGridConstants.filter.STARTS_WITH
                }});
                columns.push({name: 'type', type : 'string', displayName : 'Type', width : '*', cellFilter : 'type'});
                columns.push({name: 'style', type : 'string', displayName : 'Style', width : '*', cellFilter : 'style'});


                var underlyings = data.underlyings;

                underlyings.forEach(function(underlying) {
                    underlying.options.forEach(function(option) {

                        var worstCase = 0;
                        var diffs = [];

                        for (var i = 0; i < option.vols.length; i++) {
                            for (var j = i; j < option.vols.length; j++) {
                                var diff = (option.vols[j] - option.vols[i]) / option.vols[i];

                                diff = diff || 0;
                                diffs.push(diff);

                                worstCase = Math.max(Math.abs(diff), worstCase);
                            }
                        }

                        var newRow = {
                            code : option.code,
                            strike : option.strike,
                            expiry : option.expiry,
                            type : option.type,
                            style : option.style,
                            vols : option.vols,
                            prices : option.prices,
                            deltas : option.deltas,
                            worstCase : worstCase,
                            diffs : diffs,
                            underlying : underlying,
                            typeFilter : option.type + '-' + option.style
                        };


                        for (var i = 0; i < newRow.vols.length; i++) {
                            newRow['vols' + i] = newRow.vols[i];
                        }

                        newTableData.push(newRow);


                    });
                });

                newTableData.sort(function (a, b) {
                    if (a.worstCase > b.worstCase) {
                        return -1;
                    }

                    if (a.worstCase < b.worstCase) {
                        return 1;
                    }

                    return 0;
                });
                $scope.gridOptionsVolatilityOverTime.data = newTableData;
                $scope.gridOptionsVolatilityOverTime.columnDefs = columns;
            })
        }]);
}
